/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import "../../CA-admin-pages/Dashboard/ClientDashboard.css";
import NoData from "../../../../assets/NoData.svg";
import Axios from "../../../../api/Axios";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import { Spin, Table, Select, Progress, Tag } from "antd";
import { Tooltip as Tip } from "antd";
import { message } from "antd";
import {
  CaAdminMenu,
  SecondaryNavCaAdmin,
} from "../../../../components/AdminComponents/MenuItems";
import { useSelector } from "react-redux";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import { useDispatch } from "react-redux";
import { setClientData } from "../../../../store/slices/OrgDetail";
import EmployeeStatus from "./modules/EmployeeStatus";
import { env } from "../../../../config";
import { ModuleColor } from "../../../../components/icons/ApplicationColor";

const ClientDashboard = () => {
  const clientInfo = useSelector((state) => state.user);
  //console.log(clientInfo.data.organization.id, "organization id");
  const { id } = clientInfo.data.organization.id;
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [subscribedProducts, setSubscribedProducts] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [level1Data, setLevel1Data] = useState({});
  const [empL3, setEmpL3] = useState([]);
  const [StructSum, setStructSum] = useState([]);
  const [sysUtil, setSysUtil] = useState({});
  const [empTypeSum, setEmpTypeSum] = useState([]);
  const [empL3Header, setEmpL3Header] = useState();
  const [loginMethodData, setLoginMethodData] = useState([]);
  const [filter, setFilter] = useState("");

  //code required for storing values--start

  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user);
  useEffect(() => {
    LoadUser();
  }, []);
  const LoadUser = async () => {
    try {
      const res = await Axios.get(
        `/organization/${userInfo.data.organization.id}/`
      );

      //console.log(res.data);

      const {
        client_id,
        name,
        dep_label,
        div_label,
        entity_label,
        logo,
        logo_url,
      } = res.data;
      dispatch(
        setClientData({
          client_id,
          name,
          dep_label,
          div_label,
          entity_label,
          logo,
          logo_url,
        })
      );
    } catch (err) {
      //console.log(err);
    }
  };

  //code required for storing values--end

  const FetchFilteredData = async (flag, day) => {
    //console.log("Filter being called")
    setFilter(flag);
    try {
      // setLoading(true);
      const res = await Axios.get(
        `/dashboard/${clientInfo.data.organization.id}`,
        {
          params: {
            flag: flag,
            day: day !== "All" ? day : "",
          },
        }
      );
      //console.log(res.data, "THIS IS RESPONSE ON FILTER");
      if (res.status === 200) {
        const state =
          flag === "employee_status"
            ? "chart"
            : flag === "employee_type_summary"
            ? "empTypeSum"
            : "login_method";
        if (state === "chart") {
          setChartData([
            {
              name: "Total",
              x: res.data?.employee_status.total_user,
              fill: "#fff",
            },
            {
              name: "Inactive",
              x: res.data?.employee_status.inactive_user,
              fill: "#ADD8E6",
            },
            {
              name: "Active",
              x: res.data?.employee_status.active_user,
              fill: "#A020F0",
            },
          ]);
        } else if (state === "empTypeSum") {
          setEmpTypeSum(res.data?.employee_type_summary);
        } else if (state === "login_method") {
          //console.log("Login Methods");
          if (Object.keys(res.data?.login_method).length > 0) {
            const loginMethods = [];
            if (res.data?.login_method.email !== undefined) {
              loginMethods.push({
                name: "Email",
                value: res.data?.login_method.email,
              });
            }
            if (res.data?.login_method.user_id !== undefined) {
              loginMethods.push({
                name: "User ID",
                value: res.data?.login_method.user_id,
              });
            }
            if (res.data?.login_method.two_step !== undefined) {
              loginMethods.push({
                name: "Two Step",
                value: res.data?.login_method.two_step,
              });
            }
            if (res.data?.login_method.unsigned !== undefined) {
              loginMethods.push({
                name: "Not Logged In",
                value: res.data?.login_method.unsigned,
              });
            }
            setLoginMethodData(loginMethods);
          } else {
            setLoginMethodData(null);
            setFilter(null);
          }
        }
        // setLoading(false);
        setFilter(null);
      }
      //console.log(res);
      setFilter(null);
      // setLoading(false);
    } catch (err) {
      //console.log(err);
    }
  };

  const LoadDashboard = async () => {
    //console.log("Load Dashboard", id);
    try {
      setLoading(true);
      const res = await Axios.get(
        `/dashboard/${clientInfo.data.organization.id}/`
      );
      //console.log(res.data);
      if (res.status === 200) {
        //console.log("Request Successful");
        if (res.data?.employee_status.total_user === 0) {
          setChartData(null);
        } else {
          setChartData([
            {
              name: "Total",
              x: res.data?.employee_status.total_user,
              fill: "#fff",
            },
            {
              name: "Inactive",
              x: res.data?.employee_status.inactive_user,
              fill: "#35b8cc",
            },
            {
              name: "Active",
              x: res.data?.employee_status.active_user,
              fill: "#A020F0",
            },
          ]);
        }
        setLevel1Data({
          activ_emp: res.data?.part_one?.employee.active_employee_count,
          new_emp: res.data?.part_one?.employee.new_employee_count,
          structure: res.data?.part_one?.structure,
          subscribed: res.data?.part_one?.subscription.subscribed_product,
          expired: res.data?.part_one?.subscription.expire_date,
          l1: res.data?.part_one?.level_1,
          l2: res.data?.part_one?.level_2,
          l3: res.data?.part_one?.level_3,
          email: res.data?.part_one?.email,
          login: res?.data?.part_one?.login_log,
          bounce: res.data?.part_one?.email?.bounce,
          delivery: res?.data?.part_one?.email.delivery,
          success: res?.data?.part_one?.login_log.Success,
          failure: res?.data?.part_one?.login_log.Failed,
        });

        setEmpL3Header(
          res.data?.employee_by_l3?.header
            ? res.data?.employee_by_l3?.header
            : "Department"
        );
        setEmpL3(res.data?.employee_by_l3.department_details);
        setStructSum(res.data?.structure_summary);
        setSysUtil(res.data?.system_utilization);
        setEmpTypeSum(res.data?.employee_type_summary);
        setSubscribedProducts(res.data?.subscription_status);
        //console.log(res.data?.login_method.length, "LENGTH OF LOGIN METHODS");
        if (Object.keys(res.data?.login_method).length > 0) {
          const loginMethods = [];
          if (res.data?.login_method.email !== undefined) {
            loginMethods.push({
              name: "Email",
              value: res.data?.login_method.email,
            });
          }
          if (res.data?.login_method.user_id !== undefined) {
            loginMethods.push({
              name: "User ID",
              value: res.data?.login_method.user_id,
            });
          }
          if (res.data?.login_method.two_step !== undefined) {
            loginMethods.push({
              name: "Two Step",
              value: res.data?.login_method.two_step,
            });
          }
          if (res.data?.login_method.unsigned !== undefined) {
            loginMethods.push({
              name: "Not Logged In",
              value: res.data?.login_method.unsigned,
            });
          }
          //  setLoginMethodData([
          //     { name: "Email", value: res.data?.login_method.email },
          //     { name: "User ID", value: res.data?.login_method.user_id },
          //     { name: "Two Step", value: res.data?.login_method.two_step },
          //     { name: "Not Signed In", value: res.data?.login_method.unsigned },
          //   ]);
          setLoginMethodData(loginMethods);
        } else {
          setLoginMethodData(null);
        }
      }
      setLoading(false);
    } catch (err) {
      //console.log(err);
    }
  };

  useEffect(() => {
    LoadDashboard();
  }, []);

  useEffect(() => {}, [chartData]);
  const chartColor = (name) => {
    const COLORS = {
      Email: "#0088FE",
      "User ID": "#FF8042",
      "Two Step": "#D03D56",
      "Not Logged In": "#12c685",
    };
    const color = COLORS[name];
    if (color) {
      return color;
    }
  };

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    // const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const radius = outerRadius + 5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    if (percent > 0.01) {
      return (
        <text
          x={x}
          y={y}
          fill="black"
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
        >
          {`${(percent * 100).toFixed(2)}%`}
        </text>
      );
    }
  };

  const truncateLongHeaders = (value, max) => {
    return value.substr(0, max) + (value.length > max ? "..." : "");
  };

  const capitalize = (text) => {
    return text.toUpperCase();
  };

  const getFormattedDate = (text, record) => {
    if (!text) {
      return ""; // return an empty string if end_date is null
    }
    const date = new Date(text);
    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate();
    //const suffix = getDaySuffix(day);
    const year = date.getFullYear();
    const formattedDate = `${month}-${day < 10 ? "0" + day : day}-${year}`;
    return formattedDate;
  };

  // function getDaySuffix(day) {
  //   if (day >= 11 && day <= 13) {
  //     return "th";
  //   }
  //   switch (day % 10) {
  //     case 1:
  //       return "st";
  //     case 2:
  //       return "nd";
  //     case 3:
  //       return "rd";
  //     default:
  //       return "th";
  //   }
  // }

  const columns = [
    {
      title: "Product",
      dataIndex: "application_name",
      width: "33%",
      render: (application_name) => (
        <Tag
          color={ModuleColor(application_name)}
          className="my-form-input-antd-test-tag small-width"
        >
          <span
            className="tag-container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              lineHeight: "3rem",
            }}
          >
            {application_name}
          </span>
        </Tag>
        // <img src={application_name} alt={application_name} style={{ width: "90px", height: "30px" }} />
      ),
    },
    {
      title: "Purchase",
      dataIndex: "start_date",
      render: getFormattedDate,
      // width: "33%",
    },
    {
      title: "Expires",
      dataIndex: "end_date",
      render: getFormattedDate,
      // width: "33%",
    },
  ];

  const dropDownValues = [
    {
      value: "15",
      label: "Last 15 days",
    },
    {
      value: "30",
      label: "Last 30 days",
    },
    {
      value: "All",
      label: "All",
    },
  ];

  return (
    <div className="full-dashboard">
      <CaSideNav props={CaAdminMenu}>
        {contextHolder}
        <SecondaryNav2 id={parseInt(id)} menuItems={SecondaryNavCaAdmin} />
        <Spin spinning={loading}>
          <div className="main-scrollable-container">
            <div className="main-container">
              {/* Part 1 dashboard, includes three data points at the top */}
              <div className="part_one">
                <div className="part_one__items">
                  <div className="part_one__element">
                    <p className="part_one_element__text-first">
                      {capitalize("Employees")}
                    </p>
                    <div className="part_one_element__container">
                      <div className="part_one_element_container_content">
                        <p className="">Active</p>
                        <span>{level1Data?.activ_emp}</span>
                      </div>
                      <div className="vertical-line"></div>
                      <div className="part_one_element_container_content">
                        <p className="grey-text">
                          New <p>(30 days)</p>
                        </p>
                        <span>{level1Data?.new_emp}</span>
                      </div>
                    </div>
                  </div>
                  {/* <div className="part_one__element">
                    <p className=" part_one_element__text-second ">
                      {capitalize("Structure")}
                    </p>

                    <div className="part_one_element__container">
                      {level1Data.structure
                        ? Object.entries(level1Data?.structure).map(
                            ([key, value], index) => {
                              return (
                                <>
                                  <Tip key={index} title={key}>
                                    <div className="part_one_element_container_content">
                                      <p className="  ">
                                        {truncateLongHeaders(key, 12)}
                                      </p>
                                      <span>{value}</span>
                                    </div>
                                  </Tip>
                                  {index < 2 ? (
                                    <div className="vertical-line"></div>
                                  ) : (
                                    ""
                                  )}
                                </>
                              );
                            }
                          )
                        : ""}
                    </div>
                  </div> */}
                  <div className="part_one__element">
                    <p className="part_one_element__text-second">
                      {capitalize("Subscription")}
                    </p>
                    <div className="part_one_element__container">
                      <div className="part_one_element_container_content">
                        <p className="">Products</p>
                        <span>{level1Data?.subscribed}</span>
                      </div>
                      <div className="vertical-line"></div>
                      <div className="part_one_element_container_content">
                        <p className="">Expiration</p>
                        <span>{getFormattedDate(level1Data?.expired)}</span>
                      </div>
                    </div>
                  </div>
                  {level1Data?.email ? (
                    <div className="part_one__element">
                      <p className="part_one_element__text-third">
                        {capitalize("email")}
                      </p>
                      <div className="part_one_element__container">
                        <div className="part_one_element_container_content">
                          <p className="">Bounce</p>
                          <span>{level1Data?.bounce}</span>
                        </div>
                        <div className="vertical-line"></div>
                        <div className="part_one_element_container_content">
                          <p className="">Delivery</p>
                          <span>{level1Data?.delivery}</span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {level1Data?.login ? (
                    <div className="part_one__element">
                      <p className="part_one_element__text-fourth">
                        {capitalize("login")}
                      </p>
                      <div className="part_one_element__container">
                        <div className="part_one_element_container_content">
                          <p className="">Success</p>
                          <span>{level1Data?.success}</span>
                        </div>
                        <div className="vertical-line"></div>
                        <div className="part_one_element_container_content">
                          <p className="">Failure</p>
                          <span>{level1Data?.failure}</span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {/* Part 2, includes chart, progress bars */}
              <div className="part_two">
                <div className="part_two__items ">
                  {/* <div className="part_two__element">
                    <div
                      className="part_two__header"
                      style={{ padding: "10px" }}
                    >
                      <p>{capitalize("Employees Status")}</p>
                      <Select
                        size="small"
                        onChange={(value) => {
                          FetchFilteredData("employee_status", value.value);
                        }}
                        labelInValue
                        defaultValue={{
                          value: "All",
                          label: "All",
                        }}
                        style={{
                          width: 100,
                        }}
                        options={dropDownValues}
                      />
                    </div>
                    <Spin
                      spinning={filter === "employee_status" ? true : false}
                    >
                      <div className="part_two__container">
                        {chartData ? (
                          <div className="part_two__content emp_status">
                            <RadialBarChart
                              label={{ position: "insideStart", fill: "#fff" }}
                              startAngle={90}
                              endAngle={480}
                              width={230}
                              height={250}
                              margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                              data={chartData}
                              innerRadius="20%"
                              outerRadius="90%"
                            >
                              <RadialBar
                                cornerRadius={28 / 2}
                                background
                                minAngle={0}
                                dataKey="x"
                                legendType="square"
                              />
                            </RadialBarChart>
                            <div className="part_two__sub_content">
                              <div className="part_two__chart_stats">
                                <p>Active</p>
                                <span style={{ color: "#A020F0" }}>
                                  {" "}
                                  {chartData && chartData[2] && chartData[2].x
                                    ? chartData[2].x
                                    : 0}
                                </span>
                              </div>
                              <div className="part_two__chart_stats">
                                <p>Inactive</p>
                                <span style={{ color: "#35b8cc" }}>
                                  {chartData && chartData[1] && chartData[1].x
                                    ? chartData[1].x
                                    : 0}
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              minHeight: "28.5rem",
                            }}
                          >
                            <img
                              src={NoData}
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )}
                      </div>
                    </Spin>
                  </div> */}

                  <EmployeeStatus
                    setFilter={setFilter}
                    FetchFilteredData={FetchFilteredData}
                    capitalize={capitalize}
                    dropDownValues={dropDownValues}
                    chartData={chartData}
                    NoData={NoData}
                    filer={filter}
                  />

                  <div className="part_two__element">
                    <div
                      className="part_two__header"
                      style={{ padding: "12px" }}
                    >
                      <p>Subscription Status</p>
                    </div>
                    <div className="part_two__container">
                      <div
                        className="part_two__content"
                        style={{
                          overflow: "auto",
                        }}
                      >
                        <Table
                          columns={columns}
                          dataSource={subscribedProducts}
                          size="small"
                          pagination={false}
                          scroll={{ y: 200 }}
                          className="custom-table"
                          style={{
                            fontFamily: "Poppins",
                            // display : 'flex',
                            // justifyContent : "center",
                            // alignItems : "center"
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="part_two__element">
                    <div
                      className="part_two__header"
                      style={{ padding: "12px" }}
                    >
                      <p>Employment Types</p>
                      <Select
                        size="small"
                        onChange={(value) => {
                          FetchFilteredData(
                            "employee_type_summary",
                            value.value
                          );
                        }}
                        labelInValue
                        defaultValue={{
                          value: "All",
                          label: "All",
                        }}
                        style={{
                          width: 100,
                        }}
                        options={dropDownValues}
                      />
                    </div>
                    <div className="part_two__container">
                      <Spin
                        spinning={
                          filter === "employee_type_summary" ? true : false
                        }
                      >
                        <div className="part_two_content chart">
                          {empTypeSum.length > 0 ? (
                            empTypeSum.map((item, index) => {
                              return (
                                <div className="individual-bar" key={index}>
                                  <span>{item.user_type}</span>
                                  <div className="progress-bar-div">
                                    <Progress
                                      percent={item.percentage}
                                      size="default"
                                      strokeColor={item.color_code}
                                      strokeLinecap="square"
                                      format={(percent) =>
                                        percent === 100
                                          ? `${item.percentage}%`
                                          : `${percent}%`
                                      }
                                      style={{
                                        color: `${item.color_code} !important`,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: "25rem",
                              }}
                            >
                              <img
                                src={NoData}
                                style={{ width: "100px", height: "100px" }}
                              />
                            </div>
                          )}
                        </div>
                      </Spin>
                    </div>
                  </div>
                </div>
              </div>

              {/* Part 3 */}
              <div className="part_three">
                <div className="part_three__items">
                  <div className="part_three__element">
                    <div
                      className="part_three__header"
                      style={{ padding: "10px" }}
                    >
                      <p>Login Methods</p>
                      <Select
                        size="small"
                        onChange={(value) => {
                          FetchFilteredData("login_method", value.value);
                        }}
                        labelInValue
                        defaultValue={{
                          value: "All",
                          label: "All",
                        }}
                        style={{
                          width: 100,
                        }}
                        options={dropDownValues}
                      />
                    </div>
                    <div className="part_three__container login-chart-header">
                      <Spin spinning={filter === "login_method" ? true : false}>
                        {loginMethodData ? (
                          <PieChart
                            width={320}
                            height={230}
                            className="login-chart"
                          >
                            <Pie
                              data={loginMethodData}
                              cx="50%"
                              cy="50%"
                              labelLine={false}
                              label={renderCustomizedLabel}
                              outerRadius={100}
                              fill="#8884d8"
                              dataKey="value"
                              startAngle={0}
                              endAngle={360}
                              minAngle={0} // Adjust this value as needed
                            >
                              {loginMethodData.map((entry, index) => (
                                <Cell
                                  key={`cell-${index}`}
                                  fill={chartColor(entry.name)}
                                />
                              ))}
                            </Pie>
                            <Tooltip />
                            <Legend
                              verticalAlign="bottom"
                              align="center"
                              height={10}
                              width={300}
                              iconSize={6}
                              className="login-chart-legend"
                            />
                          </PieChart>
                        ) : (
                          <div
                            style={{
                              width: "400px",
                              height: "250px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={NoData}
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )}
                      </Spin>
                    </div>
                  </div>

                  <div className="part_three__element">
                    <div
                      className="part_three__header"
                      style={{ padding: "12px" }}
                    >
                      <p>System Utilization</p>
                    </div>
                    <div className="part_three__container">
                      <div className="part_three__content">
                        <div className="part_three_conntent__scrollable">
                          {Object.keys(sysUtil).length > 0 ? (
                            Object.entries(sysUtil).map(
                              ([key, value], index) => {
                                return (
                                  <div
                                    className="system_utilzation__container"
                                    key={index}
                                  >
                                    <p className="system_utilzation__text">
                                      {key}
                                    </p>
                                    <div className="system_utilzation__number">
                                      <p>{value}</p>
                                    </div>
                                  </div>
                                );
                              }
                            )
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={NoData}
                                style={{ width: "100px", height: "100px" }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="part_three__element">
                    <div
                      className="part_three__header"
                      style={{ padding: "12px" }}
                    >
                      <p>Structure Summary</p>
                    </div>
                    <div className="part_three__container">
                      <div className="part_three__content">
                        {StructSum.map((item) => (
                          <Tip title={item.name}>
                            <div className="structure_summary__element">
                              <p className="structure_summary__text">
                                {truncateLongHeaders(item.name, 12)}
                              </p>
                              <div className="structure_summary__number">
                                <p style={{ color: "#e4a802" }}>
                                  {item.no_of_level}
                                </p>
                                <div className="structure_summary_vertical_line"></div>
                                <p style={{ color: "#003385" }}>
                                  {item.no_of_user}
                                </p>
                              </div>
                            </div>
                          </Tip>
                        ))}
                      </div>

                      <div className="structure-summary-description">
                        <div className="structure-summary-desc-container">
                          <div
                            className="square"
                            style={{ backgroundColor: "#e4a802" }}
                          ></div>
                          <p># of Hierarchy</p>
                        </div>
                        <div className="structure-summary-desc-container">
                          <div
                            className="square"
                            style={{ backgroundColor: "#003385" }}
                          ></div>
                          <p># of Managers</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="part_three__element">
                    <div
                      className="part_three__header"
                      style={{ padding: "12px" }}
                    >
                      <p>{`Employees by ${empL3Header}`}</p>
                    </div>
                    <div className="part_three__container">
                      <div className="part_three__content">
                        {empL3 ? (
                          <div className="employee_by_dept_scroll">
                            {empL3.map((item, index) => (
                              <Tip title={item.dep_name} key={index}>
                                <div className="employee_by_department-container">
                                  <span>
                                    {truncateLongHeaders(item.dep_name, 20)}
                                  </span>
                                  <div className="employee_by_department-number">
                                    <p>{item.user_count}</p>
                                  </div>
                                </div>
                              </Tip>
                            ))}
                          </div>
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={NoData}
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </CaSideNav>
    </div>
  );
};

export default ClientDashboard;
